document.addEventListener('alpine:init', () => {
  Alpine.data('DeliveryETA', () => ({
    min: 4,
    max: 6,
    display_text: '',
    init() {
      this.InitWatchers();
      this.$nextTick(this.UpdateText.bind(this));
    },
    InitWatchers() {
      this.$watch('min', this.UpdateText.bind(this));
      this.$watch('max', this.UpdateText.bind(this));

      // watch currency change
      let _this = this;
      let bcurr_loaded = false;
      let t = setInterval(() => {
        if (window.bacurr$) {
          clearInterval(t);
          bcurr_loaded = true;
          _this.SetRange();
          // console.log('bacurr loaded');
          bacurr$('.currMovers').on('click', () => {
            setTimeout(_this.SetRange.bind(_this), 500);
          });
        }
      }, 1000);
    },
    SetRange() {
      let range_aud = this.$el.dataset.range_aud;
      let selected_currency = !window.bacurr$ ? 'AUD' : window.bacurr$('.ba-chosen').text();
      if (selected_currency == 'AUD' && range_aud) {
        let range = range_aud.split('-');
        this.min = parseInt(range[0]);
        this.max = parseInt(range[1]);
      }

      let range_nzd = this.$el.dataset.range_nzd;
      if (selected_currency == 'NZD' && range_nzd) {
        let range = range_nzd.split('-');
        this.min = parseInt(range[0]);
        this.max = parseInt(range[1]);
      }

      let range_usd = this.$el.dataset.range_usd;
      if (selected_currency == 'USD' && range_usd) {
        let range = range_usd.split('-');
        this.min = parseInt(range[0]);
        this.max = parseInt(range[1]);
      }

      let range_cad = this.$el.dataset.range_cad;
      if (selected_currency == 'CAD' && range_cad) {
        let range = range_cad.split('-');
        this.min = parseInt(range[0]);
        this.max = parseInt(range[1]);
      }

      let range_eur = this.$el.dataset.range_eur;
      if (selected_currency == 'EUR' && range_eur) {
        let range = range_eur.split('-');
        this.min = parseInt(range[0]);
        this.max = parseInt(range[1]);
      }
    },
    UpdateText() {
      let min = this.min, max = this.max;
      let add_offset = 0;
      let date_min = u_AddWeekDays(new Date(), min+add_offset);
      let date_max = u_AddWeekDays(new Date(), max+add_offset);

      this.display_text = `${u_FormatDate(date_min)} - ${u_FormatDate(date_max)}`;
    }
  }));

  Alpine.data('ProductGalleryNavigation', () => ({
    init() {},
  }));

  Alpine.data('MediaThumbnail', () => ({
    e_ScrollToMedia(e) {
      let media_id = e.currentTarget.dataset.media;
      if (!media_id) return;
      let is_desktop = window.matchMedia('(min-width: 768px)').matches;
      if (!is_desktop) return;
      let $figure = document.querySelector(`figure[data-media="${media_id}"]`);
      if (!$figure) return;
      window.scrollTo({
        top: $figure.offsetTop + ($figure.clientHeight / 2),
        behavior: 'smooth'
      });
    }
  }));

  Alpine.data('ProductFormWrap', () => ({
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      u_OnElementLoad('.quantity-x-product-widget', ($app) => {
        if (!$app) return;
        $app.addEventListener('change', (e) => {
          // console.log(e);
          let $selected = $app.querySelector('.wrapper_choose_list_item_selected');
          if (!$selected) return;
          let qty = parseInt($selected.getAttribute('for').split('_')[1]) + 1;

          let $qty = this.$el.querySelector('input[name="quantity"]');
          if (!$qty) return;
          $qty.value = qty;
          $qty.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  }));

  Alpine.data('QuantitySelector', () => ({
    quantity: 1,
    e_QtyChanged(e) {
      console.log(e, e.currentTarget.value)
      let qty = parseInt(e.currentTarget.value);
      if (qty < 1) {
        qty = 1;
      }
      this.quantity = qty;
    }
  }));

  Alpine.data('annoucementbarSlider', () => ({
    swiper: null,
    
    init() {
      this.$nextTick(() => {
        this.swiper = new Swiper('.pxs-announcement-bar-slider', {
          direction: 'vertical',
          loop: false,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          effect: 'slide',
          speed: 800,
          allowTouchMove: false,
          simulateTouch: false,
          on: {
            init() {
              // set root attribute for height
              let $root = document.body;
              let height = this.wrapperEl.closest('.shopify-section--announcements').clientHeight;
              $root.style.setProperty('--pxs-announcement-bar-height', `${height}px`);
            }
          }
        });
      });
    }
  }));

  Alpine.data('ProductOptionSwatchButton', () => ({
    e_SelectOption(e) {
      let value = e.currentTarget.dataset.value;
      let selectId = e.currentTarget.dataset.selectId;
      let $select = document.getElementById(selectId);
      if (!$select) return;
      $select.value = value;
      $select.dispatchEvent(new Event('change', { bubbles: true }));

      // set active class
      let $buttons = e.currentTarget.parentElement.querySelectorAll('.swatch-btn');
      $buttons.forEach(($btn) => {
        $btn.classList.remove('active');
      });
      e.currentTarget.classList.add('active');
    }
  }));

  Alpine.data('featuredCollectionSwiper', (opts = {}) => {
    const perRow = Math.min(4, Math.max(1, parseInt(String(opts.perRow), 10) || 3));

    function scrollProgress01(s) {
      if (!s) {
        return 0;
      }
      const min = s.minTranslate();
      const max = s.maxTranslate();
      const span = max - min;
      if (!Number.isFinite(span) || Math.abs(span) < 0.01) {
        return 0;
      }
      return Math.max(0, Math.min(1, (s.getTranslate() - min) / span));
    }

    function updateProgress(s) {
      if (!s || s.destroyed) {
        return;
      }
      const root = s.el && s.el.closest && s.el.closest('.featured-collection__swiper-stack');
      if (!root) {
        return;
      }
      const bar = root.querySelector('[data-fc-swiper-progress]');
      const fill = root.querySelector('[data-fc-swiper-progress-scrolled]');
      if (!fill) {
        return;
      }
      const p = scrollProgress01(s);
      const remaining = Math.round((1 - p) * 100);
      fill.style.width = `${p * 100}%`;
      if (bar) {
        bar.setAttribute('aria-valuenow', String(remaining));
      }
    }

    return {
      swiper: null,
      init() {
        this.$nextTick(() => {
          this.mountSwiper();
        });
      },
      mountSwiper() {
        if (typeof window.Swiper === 'undefined') {
          return;
        }
        const el = this.$el.querySelector('[data-featured-collection-swiper]');
        if (!el) {
          return;
        }
        if (el.swiper) {
          el.swiper.destroy(true, true);
        }
        const prev = this.$el.querySelector('.fc-swiper-button--prev');
        const next = this.$el.querySelector('.fc-swiper-button--next');
        if (!prev || !next) {
          return;
        }
        this.swiper = new window.Swiper(el, {
          speed: 400,
          slidesPerView: 1.25,
          spaceBetween: 16,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
          watchOverflow: true,
          watchSlidesProgress: true,
          freeMode: {
            enabled: true,
            momentum: true,
            momentumBounce: true,
            minimumVelocity: 0.01,
            sticky: false,
          },
          navigation: {
            prevEl: prev,
            nextEl: next,
          },
          breakpoints: {
            576: {
              slidesPerView: 2,
              spaceBetween: 24,
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
            },
            768: {
              slidesPerView: Math.min(3, perRow),
              spaceBetween: 28,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
            },
            992: {
              slidesPerView: perRow,
              spaceBetween: 36,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
            },
          },
          on: {
            init: function onFcInit() {
              const s = this;
              requestAnimationFrame(() => {
                if (!s || s.destroyed) {
                  return;
                }
                updateProgress(s);
              });
            },
            setTranslate: function onFcSetTranslate() {
              updateProgress(this);
            },
            progress: function onFcProgress() {
              updateProgress(this);
            },
            transitionEnd: function onFcTransitionEnd() {
              updateProgress(this);
            },
            slideChange: function onFcSlideChange() {
              updateProgress(this);
            },
            resize: function onFcResize() {
              const s = this;
              requestAnimationFrame(() => {
                if (!s || s.destroyed) {
                  return;
                }
                updateProgress(s);
              });
            },
          },
        });
      },
    };
  });
});

(function productGallerySwiper() {
  const MQL = window.matchMedia('(max-width: 767px)');

  function getSelectedIndex(gallery) {
    const fig = gallery.querySelector('figure[data-product-gallery-selected="true"]');
    if (!fig) return 0;
    const idx = parseInt(fig.getAttribute('data-product-gallery-figure'), 10);
    return Number.isNaN(idx) ? 0 : idx;
  }

  function updateSelection(gallery, index, touchHidden) {
    const hide = touchHidden !== false;
    const figures = gallery.querySelectorAll('[data-product-gallery-figure]');
    const thumbs = gallery.querySelectorAll('[data-product-gallery-thumbnail]');
    figures.forEach((f) => {
      const i = parseInt(f.getAttribute('data-product-gallery-figure'), 10);
      f.setAttribute('data-product-gallery-selected', i === index ? 'true' : 'false');
      if (hide) {
        if (i === index) {
          f.removeAttribute('hidden');
        } else {
          f.setAttribute('hidden', '');
        }
      }
    });
    thumbs.forEach((t) => {
      const i = parseInt(t.getAttribute('data-product-gallery-thumbnail'), 10);
      t.setAttribute('data-product-gallery-selected', i === index ? 'true' : 'false');
    });
  }

  function stripHiddenForSwiper(gallery) {
    gallery.querySelectorAll('.sv-product-gallery__swiper [data-product-gallery-figure]').forEach((f) => {
      f.removeAttribute('hidden');
    });
  }

  function removeLoopClones(el) {
    if (!el) {
      return;
    }
    el.querySelectorAll('.swiper-slide[data-sv-loop-clone]').forEach((node) => node.remove());
  }

  function appendLoopClonesIfNeeded(el) {
    const wrapper = el.querySelector('.swiper-wrapper');
    if (!wrapper) {
      return;
    }
    removeLoopClones(el);
    const originals = [...wrapper.querySelectorAll('.swiper-slide:not([data-sv-loop-clone])')];
    if (originals.length < 4 && originals.length >= 2) {
      originals.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('data-sv-loop-clone', 'true');
        wrapper.appendChild(clone);
      });
    }
  }

  function mountGallerySwiper(gallery, el) {
    stripHiddenForSwiper(gallery);
    appendLoopClonesIfNeeded(el);
    const targetIndex = getSelectedIndex(gallery);
    const totalSlides = el.querySelectorAll('.swiper-slide').length;
    const loop = totalSlides >= 3;
    el.classList.remove('sv-product-gallery--ready');
    return new window.Swiper(el, {
      centeredSlides: true,
      slidesPerView: 1.2,
      spaceBetween: 12,
      watchOverflow: false,
      watchSlidesProgress: true,
      loop,
      speed: 0,
      resizeObserver: false,
      on: {
        init() {
          const s = this;
          function alignToTarget() {
            if (s.destroyed) {
              return;
            }
            s.update();
            if (loop) {
              s.slideToLoop(targetIndex, 0, false);
              if (typeof s.loopFix === 'function') {
                s.loopFix();
              }
            } else {
              s.slideTo(targetIndex, 0, false);
            }
            updateSelection(gallery, s.realIndex, false);
            s.params.speed = 400;
            requestAnimationFrame(() => {
              if (s.destroyed) {
                return;
              }
              s.update();
              el.classList.add('sv-product-gallery--ready');
            });
          }
          requestAnimationFrame(alignToTarget);
        },
        slideChange() {
          updateSelection(gallery, this.realIndex, false);
        },
      },
    });
  }

  function unmountGallerySwiper(gallery) {
    const el = gallery.querySelector('.sv-product-gallery__swiper');
    if (!el) {
      return;
    }
    if (el.swiper) {
      const idx = typeof el.swiper.realIndex === 'number' ? el.swiper.realIndex : getSelectedIndex(gallery);
      el.swiper.destroy(true, true);
      updateSelection(gallery, idx, true);
    }
    removeLoopClones(el);
  }

  function syncProductGallerySwipers() {
    document.querySelectorAll('.product-gallery').forEach((gallery) => {
      const el = gallery.querySelector('.sv-product-gallery__swiper');
      if (!el || !el.hasAttribute('data-sv-slide-count')) {
        return;
      }
      const count = parseInt(el.getAttribute('data-sv-slide-count'), 10);
      if (count < 2) {
        return;
      }
      if (!MQL.matches) {
        unmountGallerySwiper(gallery);
        return;
      }
      if (typeof window.Swiper === 'undefined') {
        return;
      }
      if (el.swiper) {
        return;
      }
      mountGallerySwiper(gallery, el);
    });
  }

  function onVariantChangeSlide(e) {
    const v = e.detail && e.detail.variant;
    if (!v || !v.featured_media) {
      return;
    }
    const id = v.featured_media.id;
    document.querySelectorAll('.product-gallery').forEach((gallery) => {
      const fig = gallery.querySelector(`figure[data-media="${id}"]`);
      if (!fig) {
        return;
      }
      const idx = parseInt(fig.getAttribute('data-product-gallery-figure'), 10);
      if (Number.isNaN(idx)) {
        return;
      }
      const el = gallery.querySelector('.sv-product-gallery__swiper');
      if (!el || !el.swiper) {
        return;
      }
      const sw = el.swiper;
      if (sw.params.loop) {
        sw.slideToLoop(idx);
      } else {
        sw.slideTo(idx);
      }
      updateSelection(gallery, idx, false);
    });
  }

  function deferredSync() {
    requestAnimationFrame(syncProductGallerySwipers);
    [50, 150, 400, 800, 1600].forEach((ms) => {
      setTimeout(syncProductGallerySwipers, ms);
    });
  }

  function observeGalleryDom() {
    const root = document.querySelector('#main-content');
    if (!root || root.dataset.svProductGalleryMo) {
      return;
    }
    root.dataset.svProductGalleryMo = '1';
    let t;
    const mo = new MutationObserver(() => {
      if (!MQL.matches) {
        return;
      }
      clearTimeout(t);
      t = setTimeout(syncProductGallerySwipers, 60);
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  function scheduleInitialSync() {
    const run = () => requestAnimationFrame(syncProductGallerySwipers);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  }
  scheduleInitialSync();
  observeGalleryDom();
  MQL.addEventListener('change', syncProductGallerySwipers);
  document.addEventListener('variant:change', onVariantChangeSlide);
  document.addEventListener('variant:change', deferredSync);
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector && e.target.querySelector('.product-gallery')) {
      deferredSync();
    }
  });
  document.addEventListener('shopify:section:unload', (e) => {
    const g = e.target.querySelector && e.target.querySelector('.product-gallery');
    if (g) {
      unmountGallerySwiper(g);
    }
  });
})();

// Sticky header on scroll: apply sticky class when scrolling up on desktop
(function () {
  const DESKTOP_BP = 960;
  const SCROLL_TOP_THRESHOLD = 50;
  const SCROLL_DELTA_THRESHOLD = 5;
  const HIDE_DURATION = 400;

  let lastScrollY = window.scrollY;
  let ticking = false;
  let hideTimeout = null;

  const sections = () => document.querySelectorAll('.shopify-section--header, .shopify-section--announcements');

  function removeSticky() {
    sections().forEach(el => el.classList.remove('sticky', 'sticky--hiding'));
  }

  function updateSticky() {
    const isDesktop = window.matchMedia(`(min-width: ${DESKTOP_BP}px)`).matches;
    if (!isDesktop) {
      sections().forEach(el => el.classList.add('sticky'));
      sections().forEach(el => el.classList.remove('sticky--hiding'));
      return;
    }

    const scrollY = window.scrollY;
    const delta = scrollY - lastScrollY;
    const scrollingUp = delta < -SCROLL_DELTA_THRESHOLD;
    const isSticky = sections()[0]?.classList.contains('sticky');
    const isHiding = sections()[0]?.classList.contains('sticky--hiding');

    if (scrollingUp && scrollY > SCROLL_TOP_THRESHOLD) {
      if (hideTimeout) clearTimeout(hideTimeout);
      sections().forEach(el => {
        el.classList.remove('sticky--hiding');
        el.classList.add('sticky');
      });
    } else if ((delta > SCROLL_DELTA_THRESHOLD || scrollY <= SCROLL_TOP_THRESHOLD) && isSticky && !isHiding) {
      if (scrollY <= SCROLL_TOP_THRESHOLD) {
        if (hideTimeout) clearTimeout(hideTimeout);
        removeSticky();
      } else {
        sections().forEach(el => el.classList.add('sticky--hiding'));
        hideTimeout = setTimeout(() => {
          removeSticky();
          hideTimeout = null;
        }, HIDE_DURATION);
      }
    }

    lastScrollY = scrollY;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateSticky();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.matchMedia(`(min-width: ${DESKTOP_BP}px)`).addEventListener('change', updateSticky);
  document.addEventListener('DOMContentLoaded', updateSticky);
})();

// Featured collection: theme editor — init Alpine on section load, destroy Swiper on unload
document.addEventListener('shopify:section:load', (e) => {
  if (window.Alpine && typeof window.Alpine.initTree === 'function') {
    window.Alpine.initTree(e.target);
  }
});
document.addEventListener('shopify:section:unload', (e) => {
  const sw = e.target.querySelector('[data-featured-collection-swiper]');
  if (sw && sw.swiper) {
    sw.swiper.destroy(true, true);
  }
});